export default {
  name: 'form',
  namespaced: true,
  state() {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {}
}
